import React from 'react';
import PropTypes from 'prop-types';

const PDPValuePropsModalV2 = ({ description }) => {
  if (!description) return null;
  return (
    <div className="mt-4">
      <div
        dangerouslySetInnerHTML={{ __html: description }}
        className="text-sm text-brand-lightest [&_p]:mb-4 [&_ul]:pl-5 [&_ul]:mb-4 [&_li]:mb-1"
      />
    </div>
  );
};

PDPValuePropsModalV2.propTypes = {
  description: PropTypes.string,
};

export default PDPValuePropsModalV2;
